import {
  USER_IDENTITY_HEADER,
  CHANNEL_HEADER,
  BROWSER_LOCALE_HEADER,
  ADBLOCK_DETECTED_HEADER,
  APP_CONNECTION_ID_HEADER,
  ATTESTATION_TOKEN_HEADER,
  AUTH_CHANNEL_HEADER,
} from "@f3/shared/identity";
import { getBrowserLocale } from "./locale";
import { v7 as uuid } from "uuid";
import type { AuthChannelType } from "@/generated/graphql";

declare global {
  interface Window {
    __fanfest_session_token_data:
      | {
          token: string | null;
          appConnectionId: string | null;
        }
      | undefined;
  }
}

const sharedHeaders: Record<string, string> = {
  // Initialize browser locale header for translations to work on all API calls
  [BROWSER_LOCALE_HEADER]: getBrowserLocale(),
  [ATTESTATION_TOKEN_HEADER]: window.__fanfest_session_token_data?.token ?? "",
  [APP_CONNECTION_ID_HEADER]:
    window.__fanfest_session_token_data?.appConnectionId ??
    // Generate a new connection ID if it doesn't exist, this will make the API fail silently
    // if the request doesn't originate from the app, since this info is set by the FE servers automatically
    uuid(),
};

export function getSharedHeaders() {
  return sharedHeaders;
}

function setSharedHeader(headerName: string, value: string | null) {
  if (value === null && headerName in sharedHeaders) {
    delete sharedHeaders[headerName];
  } else if (value !== null) {
    sharedHeaders[headerName] = value;
  }
}

export function setAuthHeaders(
  value: {
    jwt: string;
    authChannel: AuthChannelType;
  } | null,
) {
  setSharedHeader(AUTH_CHANNEL_HEADER, value?.authChannel ?? null);
  setSharedHeader(USER_IDENTITY_HEADER, value?.jwt ?? null);
}

export function setChannelHeader(channelId: string | null) {
  setSharedHeader(CHANNEL_HEADER, channelId);
}

export function setLogRocketSessionURL(url: string) {
  setSharedHeader("X-LogRocket-URL", url);
}

export function setAdBlockDetectedHeader(detected: boolean) {
  setSharedHeader(ADBLOCK_DETECTED_HEADER, detected ? "true" : "false");
}
